if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(24|378|428|544|563|831)|2(066|092|26|272)|3(43[02]|129|181|200|273|816)|4(073|235|280|315|344|536|694)|5(505|634|772)|6(4(04|31|98)|285|534)|7(25[09]|146|34)|8(32[19]|245|581|630|929)|9(03|349|536|716|771|961))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}